// extracted by mini-css-extract-plugin
export var quillEditor = "_pg-1";
export var variable = "_pg-0";